/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import PersonTranslations from "./personTranslations";
import abstractCaseTranslations from "./abstractCaseTranslations";

const trafficTranslations = {
  ...abstractCaseTranslations,
  label: "Verkehr",
  accusation: {
    label: "Was wird Ihnen vorgeworfen?",
    options: {
      distance: { label: "Abstandsverstoß" },
      red_light: { label: "Rotlichtverstoß" },
      speeding: { label: "Geschwindigkeitsverstoß" },
      other: { label: "Handy / Drogen / Parken / Sonstiges" },
    },
  },
  authorityNotification: {
    label: "Welches Schreiben haben Sie zuletzt von der Behörde erhalten?",
    options: {
      hearing_report: { label: "Anhörungsbogen" },
      witness_report: { label: "Zeugenfragebogen" },
      fine_notice: { label: "Bußgeldbescheid" },
      no_notice: { label: "Noch keine Post von der Behörde" },
    },
  },
  locality: {
    label: "Wo waren Sie unterwegs?",
    options: {
      in_town: { label: "Innerorts" },
      out_of_town: { label: "Außerorts" },
      unknown: { label: "Ich bin mir nicht sicher" },
    },
  },
  speeding: {
    label: "Wie viel km/h waren Sie zu schnell?",
    options: {
      "0-20": { label: "0 - 20 km/h " },
      "21-30": { label: "21 - 30 km/h" },
      "31-40": { label: "31- 40 km/h" },
      ">40": { label: "Mehr als 40 km/h" },
      unknown: { label: "Ich bin mir nicht sicher" },
    },
  },
  driversLicensePeriod: {
    label: "Wie lange besitzen Sie schon Ihren Führerschein?",
    options: {
      "<2": { label: "Unter 2 Jahre (Probezeit)" },
      "2-10": { label: "2 - 10 Jahre" },
      ">10": { label: "Über 10 Jahre" },
    },
  },
  flensburgPoints: {
    label: "Wie viele Punkte in Flensburg haben Sie bereits?",
    options: {
      none: { label: "Keine" },
      "1-3": { label: "1 - 3 Punkte" },
      "4-8": { label: "4 - 8 Punkte" },
      unknown: { label: "Ich bin mir nicht sicher" },
    },
  },
  flashed: {
    label: "Wurden Sie in den letzten 12 Monaten schon mal geblitzt?",
    options: {
      yes: { label: "Ja" },
      no: { label: "Nein" },
      true: { label: "Ja" },
      false: { label: "Nein" },
      unknown: { label: "Ich bin mir nicht sicher" },
    },
  },
  driversLicenseIndispensable: {
    label: "Sind Sie auf Ihren Führerschein angewiesen?",
    options: {
      yes_professional: { label: "Ja, aus beruflichen Gründen" },
      yes_other: { label: "Ja, aus sonstigen Gründen" },
      no: { label: "Nein" },
    },
  },
  fineNoticeReceivedDate: {
    label: "Bescheid erhalten am",
    question: "Wann haben Sie den Bußgeldbescheid erhalten?",
  },
  client: { ...PersonTranslations },
  customer: PersonTranslations,
  roadUsersEndangered: {
    label: "Haben Sie andere Verkehrsteilnehmer gefährdet?",
    options: {
      yes: { label: "Ja" },
      no: { label: "Nein" },
      true: { label: "Ja" },
      false: { label: "Nein" },
      unknown: { label: "Ich bin mir nicht sicher" },
    },
  },
  damage: {
    label: "Haben Sie etwas beschädigt?",
    options: {
      yes: { label: "Ja" },
      no: { label: "Nein" },
      true: { label: "Ja" },
      false: { label: "Nein" },
      unknown: { label: "Ich bin mir nicht sicher" },
    },
  },
  redLight: {
    label: "Wie lange war die Ampel schon rot?",
    options: {
      under_1_sec: { label: "Unter 1 Sekunde" },
      "1_sec_or_more": { label: "1 Sekunde oder länger" },
      unknown: { label: "Ich bin mir nicht sicher" },
    },
  },
  distance: {
    label: "Wie viel Abstand hatten Sie zu dem Fahrzeug vor Ihnen?",
    options: {
      "5/10": { label: "Weniger als 5/10 des halben Tachowerts" },
      "4/10": { label: "Weniger als 4/10 des halben Tachowerts" },
      "3/10": { label: "Weniger als 3/10 des halben Tachowerts" },
      "2/10": { label: "Weniger als 2/10 des halben Tachowerts" },
      "1/10": { label: "Weniger als 1/10 des halben Tachowerts" },
      unknown: { label: "Ich bin mir nicht sicher" },
    },
  },
  speed: {
    label: "Wie schnell waren Sie unterwegs?",
    options: {
      "<81": { label: "Unter 81 km/h" },
      "81-100": { label: "81 - 100 km/h" },
      "101-130": { label: "101 - 130 km/h" },
      ">130": { label: "Über 130 km/h" },
      unknown: { label: "Ich bin mir nicht sicher" },
    },
  },
  accusationOther: {
    label: "Bitte wählen Sie hier genauer aus, was Ihnen vorgeworfen wird.",
    options: {
      mobile_phone: { label: "Handyverstoß" },
      drugs: { label: "Alkohol-/Drogenverstoß" },
      parking: { label: "Parkverstoß" },
      other: { label: "Anderer Tatvorwurf" },
    },
  },
  vehicle: {
    label: "Womit waren Sie unterwegs?",
    options: {
      car: { label: "PKW" },
      bike: { label: "Fahrrad" },
      motorcycle: { label: "Motorrad" },
      truck: { label: "LKW" },
      bus: { label: "Bus" },
    },
  },
};

export default trafficTranslations;
